// https://stackoverflow.com/questions/196972/convert-string-to-title-case-with-javascript
/**
 * this function accepts a string input and return the string in Title Case 
 * e.g. hello WORLD -> Hello World
 * @param str - input string to title case
 * @returns title cased string
 */
export const ToTitleCase = (str:string):string => {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
        }
    );
}